import React from 'react';
import BlockIcon from '@mui/icons-material/Block';
import { NEEDS_PAINT } from '../nodeProps';
import styles from './sections.module.css';

/**
 * The "⊘ None" choice of a style picker (the border). `ariaLabel` names it fully for screen readers; `isLocked`
 * disables it when it would leave the shape with neither fill nor border.
 */
export const noneOption = ({ value, ariaLabel, isLocked }) => ({
    value,
    label: 'None',
    ariaLabel,
    icon: <BlockIcon className={styles.noneIcon} />,
    disabled: isLocked,
    title: isLocked ? NEEDS_PAINT : undefined,
});
